import { render, staticRenderFns } from "./QuickPay.vue?vue&type=template&id=b6ba8dba"
import script from "./QuickPay.vue?vue&type=script&lang=js"
export * from "./QuickPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports